import CoursesService from '@/services/CoursesService';

const state = {
    categories: [],
    loading: false,
    loaded: false
};

const getters = {
    categories: (state) => state.categories,
    getCategoryById: (state) => (id) => {
        return state.categories.find(category => category.id === id);
    }
};

const mutations = {
    setCategories(state, categories) {
        state.categories = categories;
        state.loaded = true;
        state.loading = false;
    },
    setLoading(state, loading) {
        state.loading = loading;
    }
};

const actions = {
    async loadCategories({ commit, state }) {
        if (state.loaded || state.loading) {
            return;
        }
        commit('setLoading', true);
        try {
            const res = await CoursesService.getCategories();
            commit('setCategories', res.data);
        } catch (error) {
            console.error('Failed to load exercise categories:', error);
            commit('setLoading', false);
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};